import script from "./EffectBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./EffectBackground.vue?vue&type=script&setup=true&lang=js"

import "./EffectBackground.vue?vue&type=style&index=0&id=becd618a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-becd618a"]])

export default __exports__